import { PreferencesService } from "app/services/preferences/preferencesService";

import { SECOND_LAND } from "../constants";

const PLATFORM_LAND_COUNT_PREF_KEY = "platform.landCount";
const PLATFORM_LAND_SESSION_GUARD_KEY = "platform.landCounted";

const MAX_TRACKED_LAND = SECOND_LAND + 1;

const getLandCount = (): number => {
    const storedLandCount = PreferencesService.get(PLATFORM_LAND_COUNT_PREF_KEY);

    return typeof storedLandCount === "number" && storedLandCount > 0 ? storedLandCount : 0;
};

const wasLandCountedThisSession = (): boolean => {
    try {
        return sessionStorage.getItem(PLATFORM_LAND_SESSION_GUARD_KEY) === "true";
    } catch {
        return false;
    }
};

const markLandCountedThisSession = (): void => {
    try {
        sessionStorage.setItem(PLATFORM_LAND_SESSION_GUARD_KEY, "true");
    } catch {
        return;
    }
};

export const registerLand = (): number => {
    const currentLandCount = getLandCount();

    if (currentLandCount >= MAX_TRACKED_LAND || wasLandCountedThisSession()) {
        return currentLandCount;
    }

    const nextLandCount = currentLandCount + 1;

    markLandCountedThisSession();
    void PreferencesService.add({
        [PLATFORM_LAND_COUNT_PREF_KEY]: nextLandCount,
    });

    return nextLandCount;
};
